<template>
  <div class="main-robot">

    <main>
      <header>
        <h3>机器人管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:robot:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加</a-button>
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search v-model.trim="pagination.searchText" placeholder="计算机/机器人/账号"
                            style="width: 200px; " allow-clear :loading="btnLoad" @input="searchTextChange"  @search="searchChange" />
          </a-form-model-item>
          <a-form-model-item prop="type">
            <a-select v-model="pagination.type" placeholder="类型" style="width: 180px; " allowClear
                      :loading="btnLoad" @change="searchChange">
              <a-select-option :value="0">无人值守</a-select-option>
              <a-select-option :value="1">有人值守</a-select-option>
              <a-select-option :value="2">设计器</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="status">
            <a-select v-model="pagination.status" placeholder="状态" style="width: 180px; "
                      allowClear :loading="btnLoad" @change="searchChange">
              <a-select-option :value="0">可用</a-select-option>
              <a-select-option :value="1">已断开连接</a-select-option>
              <a-select-option :value="2">忙碌</a-select-option>
              <a-select-option :value="3">无响应</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-select v-model="pagination.orgId" placeholder="部门" style="width: 180px;" allowClear
                      :loading="btnLoad"    show-search  @change="searchChange" :filter-option="filterOption"    :filterOption="filterOption">
              <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="environmentId">
            <a-select v-model="pagination.environmentId" placeholder="环境" style="width: 180px;" allowClear
                      :loading="btnLoad" @change="searchChange">
              <a-select-option  v-for="item in environmentList" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="enable">
            <a-select v-model="pagination.enable" placeholder="活动" style="width: 180px;" allowClear
                      :loading="btnLoad" @change="searchChange">
              <a-select-option :value="0">禁用</a-select-option>
              <a-select-option :value="1">启用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>

        </a-form-model>

      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered :data-source="tableData" :pagination="queryCondition" :loading="tableLoad"
        @change="handleTableChange" :scroll="{ y: 560 }">
        <template slot="type" slot-scope="text">
          <span v-if="text === 0">
            <a-tag color="blue">无人值守</a-tag>
          </span>
          <span v-if="text === 1">
            <a-tag color="cyan">有人值守</a-tag>
          </span>
          <span v-if="text === 2">
            <a-tag color="purple">设计器</a-tag>
          </span>
        </template>
        <template slot="enable" slot-scope="text, record">
          <a-popconfirm
              :title="text == 1 ? '是否禁用该机器人?' : '是否启用该机器人?' "
              ok-text="确定"
              cancel-text="取消"
              @confirm="switchConfirm"
          >
            <a-switch  @change="onChange($event,record)" :checked="text == 1 ? true : false "  />

          </a-popconfirm>
        </template>
        <template slot="status" slot-scope="text">
          <span v-if="text === 0">
            <img class="img-lc" src="../assets/images/available.png">可用
          </span>
          <span v-if="text === 1">
            <img class="img-lc" src="../assets/images/interruptImg.png">已断开连接
          </span>
          <span v-if="text === 2">
              <img  class="img-lc" src="../assets/images/busyImg.png">忙碌
          </span>
          <span v-if="text === 3">
            <img class="img-lc" src="../assets/images/norespImg.png">无响应
          </span>
        </template>
        <span slot="action" slot-scope="record" class="table-action-box">
             <a-tooltip  content="" v-if=" record.status == 0" title="重启" placement="top" effect="light">
              <i class="table-restart" @click="handleOpen('重启', record)" ></i>
            </a-tooltip>
           <a-tooltip  content="" v-if="$IA('system:robot:update')" title="修改" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:robot:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>

        </span>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal centered :visible="modalVisible" :confirm-loading="btnLoad"
      @ok="handleOk('addForm')" @cancel="resetForm"  :width="(modalTitle == '删除' || modalTitle == '重启') ? '420px' : '600px'"  :title="(modalTitle == '删除' || modalTitle == '重启') ? modalTitle + '机器人' : '' " :closable="false" :confirmLoading="submitLoad"  :maskClosable="false">


      <a-form-model layout="vertical"  v-if="['添加', '修改'].includes(modalTitle)" ref="addForm" :model="addForm" :rules="addFormRules">

        <a-form-model-item prop="id" v-show="false">
          <a-input v-model="addForm.id" placeholder="请输入" />
        </a-form-model-item>


        <a-row :gutter="16">
          <a-tabs :activeKey="activeKey" class="robotTabs" @change="callback">
            <a-tab-pane key="1" :tab="modalTitle == '添加' ? '添加' : '修改'">
                <a-col :span="12">
                  <a-form-model-item label="计算机名称" prop="machineId">
                    <a-select    show-search :filter-option="filterOption" :disabled="modalTitle == '修改'" v-model="addForm.machineId" placeholder="请选择" @change="robotChange">
                      <a-select-option :key="item.id" v-for="item in this.robotList" :value="item.id" :label="item.name">
                        {{ item.name }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item  prop="type">
                    <template slot="label" >
                      <span class="ant-form-item-required">类型</span>
                    </template>
                    <a-select v-model="addForm.type" placeholder="请选择" @change="typeChange">
                      <a-select-option :value="0">无人值守</a-select-option>
                      <a-select-option :value="1">有人值守</a-select-option>
                      <a-select-option :value="2">设计器</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="机器人名称" prop="name">
                    <a-input v-model="addForm.name" placeholder="请输入" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="域\用户名" prop="username">
                    <a-input v-model="addForm.username" placeholder="请输入" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12" v-if=" addForm.type == 0">
                  <a-form-model-item label="密码" prop="password">
                    <a-input-password v-model="addForm.password" placeholder="请输入" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="部门" prop="orgName">
                    <a-input v-model="addForm.orgName" disabled placeholder="请输入" />
                    <!-- <a-select v-model="addForm.orgId" placeholder="请选择" :disabled="modalTitle == '修改'">
                      <a-select-option v-for="v in orgList" :key="v.id" :value="v.id">
                        {{ v.name }}
                       </a-select-option>
                    </a-select> -->
                  </a-form-model-item>
                </a-col>
              <a-col :span="12">
              </a-col>
                <a-col :span="24">
                  <a-form-model-item label="描述" prop="description">
                    <a-textarea v-model="addForm.description" placeholder="请输入" />
                  </a-form-model-item>
                </a-col>
            </a-tab-pane>
            <a-tab-pane key="2" tab="设置" force-render>
              <a-col :span="24">
                <a-form-model-item label="日志级别" prop="logLevel">
                  <a-select v-model="addForm.logLevel" placeholder="请选择">
                    <a-select-option value="Info">消息</a-select-option>
                    <a-select-option value="Warning">警告</a-select-option>
                    <a-select-option value="Error">错误</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="24" >
                <a-form-model-item prop="sessionType">
                  <template slot="label">
                    会话类型
                    <a-tooltip  content="" placement="right" effect="light">
                      <template slot="title">
                        <span> 当Robot为实体机，选择控制台会话，当Robot为虚拟机，选择RDP会话</span>
                      </template>
                      <i class="el-icon-warning" style="color: #3373f2;"></i>
                    </a-tooltip>
                  </template>

                  <a-radio-group v-model="addForm.sessionType" @change="radioChagne">
                    <a-radio :value="0">
                      控制台会话
                    </a-radio>
                    <a-radio :value="1">
                      RDP会话
                    </a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
<!--              <a-col :span="24">-->
<!--                <a-form-model-item label="分辨率" prop="logLevel">-->
<!--                  <a-select v-model="addForm.logLevel" placeholder="请选择">-->
<!--                    <a-select-option value="1920 x 1080">1920 x 1080 (推荐)</a-select-option>-->
<!--                    <a-select-option value="1680 x 1050">1680 x 1050 </a-select-option>-->
<!--                    <a-select-option value="1600 x 900">1600 x 900 </a-select-option>-->
<!--                    <a-select-option value="1440 x 900">1440 x 900 </a-select-option>-->
<!--                    <a-select-option value="1440 x 1050">1440 x 1050 </a-select-option>-->
<!--                    <a-select-option value="1366 x 768">1366 x 768 </a-select-option>-->
<!--                    <a-select-option value="1360 x 768">1360 x 768 </a-select-option>-->
<!--                    <a-select-option value="1280 x 1024">1280 x 1024 </a-select-option>-->
<!--                    <a-select-option value="1280 x 800">1280 x 800 </a-select-option>-->
<!--                    <a-select-option value="1280 x 768">1280 x 768 </a-select-option>-->
<!--                    <a-select-option value="1280 x 720">1280 x 720 </a-select-option>-->
<!--                    <a-select-option value="1024 x 768">1024 x 768 </a-select-option>-->
<!--                    <a-select-option value="800 x 600">800 x 600 </a-select-option>-->
<!--                  </a-select>-->
<!--                </a-form-model-item>-->
<!--              </a-col>-->
              <a-col :span="24"  v-if="addForm.sessionType == 1 ">
                <a-form-model-item  prop="resolutionX">
                  <template slot="label">
                    横向分辨率
                    <a-tooltip  content="" placement="right" effect="light">
                      <template slot="title">
                        <span> 当为控制台会话，分辨率设置无效，实际为系统本身分辨率</span>
                      </template>
                      <i class="el-icon-warning" style="color: #3373f2;"></i>
                    </a-tooltip>
                  </template>
                  <a-input-number placeholder="请输入" style="width: 100%" v-model="addForm.resolutionX" :min="0" :max="999999"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="24" style="margin-bottom: 38px" v-if="addForm.sessionType == 1">
                <a-form-model-item label="纵向分辨率" prop="resolutionY">
                  <a-input-number placeholder="请输入" style="width: 100%" v-model="addForm.resolutionY" :min="0" :max="999999"/>
                </a-form-model-item>
              </a-col>
            </a-tab-pane>
          </a-tabs>
        </a-row>


      </a-form-model>


      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该机器人,是否继续?</p>
      </div>

      <div class="deleteBox" v-if="modalTitle == '重启'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将重启该机器人,是否继续?</p>
      </div>


    </a-modal>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";
// 引入websocket
import useWS from "@/utils/websocket";

export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      pagination: {
        searchText: '',
        type: undefined,
        status: undefined,
        orgId:undefined,
        environmentId:undefined,
        enable:undefined,
        pageSize: 10,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '机器人名称',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,

        },
        {
          title: '计算机名称',
          dataIndex: 'machineName',
          key: 'machineName',
          ellipsis: true,
        },
        {
          title: '部门',
          dataIndex: 'orgName',
          key: 'orgName',
          ellipsis: true,
          width: 120
        },
        {
          title: '环境',
          key: 'robotEnvironments',
          dataIndex: 'robotEnvironments',
          scopedSlots: { customRender: "robotEnvironments" },
          width: 120,
          ellipsis: true,
        },

        {
          title: '账号',
          key: 'username',
          dataIndex: 'username',
          ellipsis: true,
        },

        {
          title: '类型',
          key: 'type',
          dataIndex: 'type',
          scopedSlots: { customRender: "type" },
          width: 120
        },
        {
          title: '状态',
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: "status" },
          width: 130
        },
        {
          title: '描述',
          key: 'description',
          dataIndex: 'description',
          ellipsis: true,
          scopedSlots: { customRender: "description" },
        },
        {
          title: '活动',
          key: 'enable',
          dataIndex: 'enable',
          scopedSlots: { customRender: "enable" },
          width: 120
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: "action" },
          align: 'center',
          width: 120,
        },
      ],
      formLayout: "inline",
      queryCondition: {},
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: '',
      // 单行数据
      singleDta: "",
      // 是否按钮loading
      submitLoad: false,
      saveApi: "", // 添加/修改保存API
      // 添加表单
      addForm: {
        id: "",
        name: "",
        machineId: undefined,
        username: "",
        password: "",
        orgName:"",
        type: undefined,
        description: "",
        orgId:undefined,
        logLevel:'Info',
        sessionType:1,
        resolutionX:0,
        resolutionY:0,
      },
      // 机器人下拉数据
      robotList: {},
      addFormRules: {
        machineId: [{ required: true, message: '计算机名称不能为空' }],
        name: [{ required: true, max: 20, message: '机器人名称最长不能超过20字符且不可为空' }],
        username: [{ required: true, max: 100, message: '域\用户名最长不能超过100字符且不可为空' }],
        password: [{ required: true, max: 32, message: '密码最长不能超过32字符且不可为空' }],
        description: [{ max: 250, message: '描述最长不能超过250字符' }],
        // type: [{ required: true, message: '类型不能为空' }],
        logLevel: [{ required: true, message: '日志级别不能为空' }],
        sessionType: [{ required: true, message: '会话类型不能为空' }],
        resolutionX: [{ required: true, message: '     横向分辨率不能为空' }],
        resolutionY: [{ required: true, message: '纵向分辨率不能为空' }],

      },
      // 分页参数
      pagCurrent:{},
      // 部门
      orgList:[],
      activeKey:'1',

      // 开关
      activityChecked:false,
      activityData:{},

      // 环境列
      environmentList:[],
      cloneData:{}
    }
  },
  methods: {
    // 通知表格刷新
    handleJobWS(type,data){
      this.tableData.forEach((item)=>{
        if (item.id == data.id){
          item.status = data.status
        }
      })
    },
    // 开启搜索
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 重置表单通用方法
    resetForm() {
      if (this.modalTitle == '添加' || this.modalTitle == '修改') {
        this.$refs.addForm.resetFields()
      }
      this.modalVisible = false
    },
    // 监听会话类型
    radioChagne(val){
      if (val.target.value == 0){
        this.addForm.resolutionX = 0
        this.addForm.resolutionY = 0
      }
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    callback(val){
      this.activeKey = val
    },
    // 监听类型  清空 无人值守密码
    typeChange(val){
      if (this.modalTitle == '修改'){
        if (this.cloneData.type == 0){
          this.addFormRules.password = [{  max: 32, message: '密码最长不能超过32字符且不可为空' }]
        }else{
          this.addFormRules.password = [{ required: true, max: 32, message: '密码最长不能超过32字符且不可为空' }]
        }
      }
      this.addForm.password = ''

    },
    // 表格字段 气泡确认框
    switchConfirm(){
      if (this.activityChecked) {
        this.switchChange(this.activityData,'/license/enable')
      }else{
        this.switchChange(this.activityData,'/license/disable')
      }
    },
    switchChange(data,api){
      this.axios
          .post(api,{robotId:data.id,robotName:data.name})
          .then((res) => {
            if (res.code == 200) {
              this.handleTableChange(this.pagCurrent);
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 表格 活动监听字段更新
    onChange(checked,record) {
      this.activityChecked = checked
      this.activityData = record
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title
      this.modalVisible = true
      this.activeKey = '1'
      this.$nextTick(() => {
        this.singleDta = data
        switch (title) {
          case '添加':
            this.saveApi = '/robot/save'
            this.allRobotList()
            this.$refs.addForm.resetFields()
            this.addFormRules.password = [{ required: true, max: 32, message: '密码最长不能超过32字符且不可为空' }]
            break;
          case '修改':
            this.saveApi = '/robot/update'
            this.addForm = this.$lodash.pick(
              this.singleDta,
                this.$lodash.keys(this.addForm)
            );
            this.allRobotList(data.orgId)
              if (this.addForm.type == 0){
                this.addFormRules.password = [{ max: 32, message: '密码最长不能超过32字符' }]
              }
            this.cloneData = this.$lodash.cloneDeep(this.addForm)

            break;
          case '删除':
            break;
        }

      })

    },
    // 确认模态框
    handleOk(formName) {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = this.$lodash.cloneDeep(this.addForm);
            if (saveData.type == 0) {
              saveData.password = saveData.password ? this.$encrypt.encrypt(saveData.password) : null
            }
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.modalVisible = false;
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.$refs.addForm.resetFields()
                  this.handleTableChange(this.modalTitle == "添加"?this.pagination:this.pagCurrent);
                }
              }) 
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
      if (this.modalTitle == '删除'){
        this.submitLoad = true;
        this.axios.delete("/robot/delete", {
          params: {
            id: this.singleDta.id,
          },
        })
            .then((res) => {
              this.submitLoad = false;
              this.handleTableChange(this.pagCurrent);
              this.modalVisible = false;
              if (res.code === 200 ) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
      if (this.modalTitle == '重启'){
        this.submitLoad = true;
        this.axios.post("/robot/reStart", {
         id: this.singleDta.id,
        })
            .then((res) => {
              this.submitLoad = false;
              this.handleTableChange(this.pagCurrent);
              this.modalVisible = false;
              if (res.code === 200 ) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
    },
    robotChange(val){
       let obj = this.robotList.find((v)=>{
        return val === v.id
     })
     this.addForm.orgId = obj.orgId
     this.addForm.orgName = obj.orgName
     console.log(obj);
    },
    // 机器人下拉框
    allRobotList(id) {
      this.axios
        .post("/machine/findMachines", 'orgId=' + (id ? id : ''))
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.robotList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true
      this.axios.post('/robot/findPage', this.$qs.stringify(this.queryCondition)).then((res) => {
        this.tableLoad = false
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.queryCondition.total = res.data.total;
        }
      }).catch((err) => {
        console.log(err);
        this.tableLoad = false
      })
    },
  },
  beforeMount() {
    this.searchChange()
    this.axios
        .post("/environment/findList")
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.environmentList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    this.axios
      .post("/org/findParentOrg",)
      .then((res) => {
        if (res.code === 200) {
            this.orgList = res.data
        }
      })
      .catch((err) => {
        console.log(err);
    });
  },
  mounted() {
    useWS('JOB', '/admin/websocket/robot:robotState', this.handleJobWS)
  }
}
</script>

<style lang="scss" scoped>
.main-robot {


  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }


    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
  }

}
.img-lc {
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -1px;
}
// 弹出框样式
.robotTabs{
  padding-top:20px;
  ::v-deep .ant-tabs-nav{
    width: 94%;
    .ant-tabs-tab{
      width: 50%;
      text-align: center;
      font-weight: 600;
    }
  }
  ::v-deep  .ant-tabs-tab-active{
    background-color: #fafafa;
  }
}
</style>